'use strict';

require('../CompanyService.js');
require('../groups/CompanyGroupService.js');
require('../CompanyCtrl.js');
require('./CompanyPublicationService.js');
require('../categories/CompanyCategoryService.js');
require('../../app/ReloadUserRoleDashboard.js');
require('../tasks/CompanyTaskService.js');
require('../tasks/CompanyTasksCtrl.js');
require('./CompanyPublicationMassEditCtrl.js');

function CompanyPublicationsListCtrl(
  $scope,
  $stateParams,
  stateSnapshot,
  $state,
  $modal,
  $timeout,
  $controller,
  publications,
  categories,
  currentCategory,
  priorities,
  userInformation,
  translations,
  CompanyGroupService,
  CompanyMessageService,
  CompanyCommentsService,
  CompanyPublicationService,
  growl,
  reloadUserRoleDashboard,
  CompanyTaskService, 
  CompanyUserService,
  $window
) {
  $scope.publications = publications;
  $scope.$state = $state;
  $scope.priorityId = $stateParams.priorityId || null;
  $scope.selectedPriority = null;
  $scope.posts = [];
  $scope.comments = [];
  $scope.latestTasks = [];
  angular.extend($scope, $controller('CompanyTasksCtrl', {$scope: $scope}));
  $scope.showPublicationForm = false;
  $scope.publicationsMassEdit = [];
  $scope.namePublications = [];

  $scope.selectedCustomerPortal = null;
  $scope.selectedCategory = null;
  $scope.more = false;
  $scope.moreCat = false;
  $scope.title = translations['all-cards'];
  $scope.currentCategory = currentCategory;
  $scope.currentType = $stateParams.type;
  $scope.showAll = $stateParams.showAll || "";
  $scope.filterTags = $stateParams.tags;
  $scope.filterqType = $stateParams.qType || 'GENERAL';
  $scope.toggleFilter = $stateParams.q || $scope.currentCategory || $scope.currentType || $scope.filterTags || $state.params.groupId || $state.params.ordeby || $state.params.from || $state.params.to || $state.params.priorityId ? false : true;

  $scope.categories = categories;

  if (!$stateParams.tags) {
    $scope.activeTags = [];
  } else {
    $scope.activeTags = $stateParams.tags.split(',');
    if (!Array.isArray($scope.activeTags)) {
      $scope.activeTags = [$scope.activeTags];
    }
  }

  if (!$stateParams.categoryId) {
    $scope.activeCategory = null;
  } else {
    categories.forEach(function(c) {
      if (c.id === $stateParams.categoryId) {
        $scope.activeCategory = c.name;
      }
    });
  }

  $scope.activeType = $stateParams.type || null;

  $scope.activeGroup = null;
  if ($stateParams.groupId) {
    CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId}, function(resp){
      $scope.activeGroup = resp;
    });
  }


  if ($stateParams.priorityId) {
    priorities.forEach(function(p) {
      if (p.id === $stateParams.priorityId) {
        $scope.activePriority = p.name;
      }
    });
  }

  if (currentCategory && currentCategory.name) {
    $scope.title = currentCategory.name;
  }

  if ($scope.publications.length === 61) {
    $scope.more = true;
    $scope.publications.pop();
  }

  $scope.priorities = priorities;
  priorities.$promise.then(function () {
    for (var i = 0; i < priorities.length; i++) {
      if (priorities[i].id === $scope.priorityId) {
        $scope.selectedPriority = priorities[i];
      }
      $scope.priorities[priorities[i].id] = priorities[i];
    }
  });

  if ($scope.role !==  null && !$stateParams.type && !$scope.showAll) {
    setTimeout(function(){
      $scope.showMoreMenu();
    }, 50);

    setTimeout(function(){
      var options = {
        alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        disableOneColumnMode: true
      };
      jQuery('.grid-stack').gridstack(options);
    }, 10);

    angular.element($window).on('resize', function () {
      var widthWindowH = angular.element($window).width();
      var grid = jQuery('.grid-stack').data('gridstack');
      if(widthWindowH < 1016 && widthWindowH > 825){
        angular.forEach($scope.role.template.data, function(value, key){
          grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), (value.chartData.gsX === "0" ? 0 : 6), value.chartData.gsY, 6, value.chartData.gsHeigth);
        });
      }else{
        if(widthWindowH >= 1016){
          angular.forEach($scope.role.template.data, function(value, key){
            grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), parseInt(value.chartData.gsX), parseInt(value.chartData.gsY), parseInt(value.chartData.gsWidth), parseInt(value.chartData.gsHeigth));
          });
        }else{
          angular.forEach($scope.role.template.data, function(value, key){
            grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), 0, parseInt(value.chartData.gsY), 12, parseInt(value.chartData.gsHeigth));
          });
        }
      }
    });
  }

  $scope.updateUserInfo = function(user){
    CompanyUserService.update({companyId: $stateParams.companyId, userId: user.id}, user, function(){
      $state.go('.', {}, {reload: true})
    });
  };

  $scope.toggleShowPublicationForm = function(isShow){
    $scope.showPublicationForm = isShow;
  };

  $scope.changeToggleFilter = function(){
    $state.go('root.company.publications-list', {
      qType: $stateParams.qType || "GENERAL",
      qTypeObject: $stateParams.qTypeObject || "OBJECT",
      togFilter: true
    });
  };

  $scope.filterByCreatedOrUpdated = function(v, asc) {
    $state.go('root.company.publications-list', {orderby: v, asc: asc});
  };

  function getBlogLastest(data){
    if(data.columnType === 'BLOG' && (data.columnData.object || data.columnData.blogId)){
      var index = $scope.role.template.data.indexOf(data);
      CompanyPublicationService.getPostLastest({
        companyId: $stateParams.companyId,
        publicationId: (data.columnData.object ? data.columnData.object.id : data.columnData.blogId),
        only: data.columnData.only,
        limit: (data.columnData.showThreePosts ? 3 : 1)
      }, function(resp){
        $scope.role.template.data[index].blogLastest = resp;
      });
    }
  }

  $scope.goToPublicationDetail = function(publication){
    if(publication.type !== 'FORM' && publication.type !== 'PUBLICATION_SPREAD_SHEET' && publication.type !== 'COMPANY_ORDER' && publication.type !== 'ORDER_SUBCRIPTION'){
      $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: publication.id});
    }else{
      if(publication.type === 'PUBLICATION_SPREAD_SHEET'){
        window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+publication.id;
      }
      if(publication.type === 'FORM'){
        if (
          publication.features.formActived === "false" ||
          !!publication.features.formActived === false
        ) {
          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/detail';
        }else{
          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/form-submit';
        }
      }
      if(publication.type === 'COMPANY_ORDER'){
        window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
      }
      if(publication.type === 'ORDER_SUBCRIPTION'){
        window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+publication.id;
      }
    }
  };

  $scope.addPublicationsMassEdit = function(publication, publicationSelected){
    if(publicationSelected){
      $scope.publicationsMassEdit.push(publication.id);
      $scope.namePublications.push(publication);
    }else{
      $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
      $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
    }
  };

  $scope.selectAllPublication = function(){
    $scope.selectAll = !$scope.selectAll;
    angular.forEach($scope.publications, function(publication){
      if($scope.selectAll){
        publication.selected = true;
        $scope.publicationsMassEdit.push(publication.id);
        $scope.namePublications.push(publication);
      }else{
        publication.selected = false;
        $scope.publicationsMassEdit = [];
        $scope.namePublications = [];
      }
    });
  };

  $scope.showModalMassEdit = function() {
    $modal({
      scope: $scope,
      controller: 'CompanyPublicationMassEditCtrl',
      templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
      show: true,
      resolve: {
        priorities: function() {
          return priorities;
        },
        groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
          return CompanyGroupService.query({
            companyId: $stateParams.companyId,
            all: true
          }).$promise;
        }],
        categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
          return CompanyCategoryService.query({
            companyId: $stateParams.companyId,
            limit: 1000
          }).$promise;
        }]
      }
    });
  };

  $scope.showModalUserLink = function(link, index) {
    $modal({
      scope: $scope,
      controller: 'CompanyUserLinksCtrl',
      templateUrl: 'partials/company/publications/lists/user-link.html',
      show: true,
      prefixEvent: 'userLinkModal',
      resolve: {
        link: function() {
          return link || false;
        },
        index: function() {
          return (angular.isUndefined(index) ? -1 : index);
        }
      }
    });
  };

  $scope.selectedPublicationType = $stateParams.type || null;
  $scope.selectedOrderBy = $stateParams.orderby || 'updated';
  $scope.selectedAsc = $stateParams.asc === "true" ? true : false;

  var startDate = Date.parse($stateParams.from);
  var endDate   = Date.parse($stateParams.to);

  $scope.filterDataSpan  = {
    from: startDate ? new Date(startDate) : null,
    to:   endDate   ? new Date(endDate)   : null
  };

  if ($scope.role !==  null && !$stateParams.type && !$scope.showAll) {
    if ($scope.role.template && ($scope.role.template.id === '1' || $scope.role.template.id === '2' || $scope.role.template.id === '5' || $scope.role.template.id === '6')) {
      var yMax = 0;
      var heigthMax = 4;
      if($scope.role.template.data){
        angular.forEach($scope.role.template.data, function(value, key){
          value.chartData = value.chartData ? value.chartData : {};
          value.chartData.gsX = angular.isDefined(value.chartData.gsX) ? value.chartData.gsX : (key%3===0 ? 0 : (key%3===1 ? 4 : 8));
          value.chartData.gsY = angular.isDefined(value.chartData.gsY) ? value.chartData.gsY : 0;
          value.chartData.gsWidth = angular.isDefined(value.chartData.gsWidth) ? value.chartData.gsWidth : 4;
          value.chartData.gsHeigth = angular.isDefined(value.chartData.gsHeigth) ? value.chartData.gsHeigth : 7;
          if(!value.isChart && value.columnType === 'BLOG'){
            getBlogLastest(value);
          }
          if(parseInt(value.chartData.gsY) > yMax){
            yMax = parseInt(value.chartData.gsY);
            heigthMax = parseInt(value.chartData.gsHeigth);
          }
        });
      }
      var boxMessage = $scope.role.template.data.filter(function(d){ return d.columnType === 'MESSAGE'; });
      if ($scope.info.features.blogs && $scope.role.showMessage) {
        CompanyMessageService.query({
          companyId: $stateParams.companyId,
          limit: 4,
          showInList: false
        }, function(resp){
          $scope.posts = resp;
          if(!boxMessage[0]){
            if($scope.posts.length > 0){
              $scope.role.template.data.push({
                isChart: false,
                centralInformation: false,
                columnType: 'MESSAGE',
                isFullBox: false,
                chartData: {
                  gsX: 0,
                  gsY: yMax+heigthMax,
                  gsWidth: 4,
                  gsHeigth: 4,
                }
              });
            }
          }else{
            if($scope.posts.length === 0){
              $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
            }
          }
        }, function(){
          if(boxMessage[0]){
            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
          }
        });
      }else{
        if(boxMessage[0]){
          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
        }
      }
      var boxComment = $scope.role.template.data.filter(function(d){ return d.columnType === 'COMMENT'; });
      if ($scope.role.showComment) {
        CompanyCommentsService.queryComments({
          companyId: $stateParams.companyId,
          limit: 4
        }, function(resp){
          $scope.comments = resp;
          if(!boxComment[0]){
            if($scope.comments.length > 0){
              $scope.role.template.data.push({
                isChart: false,
                centralInformation: false,
                columnType: 'COMMENT',
                isFullBox: false,
                chartData: {
                  gsX: 0,
                  gsY: yMax+heigthMax,
                  gsWidth: 4,
                  gsHeigth: 4,
                }
              });
            }
          }else{
            if($scope.comments.length === 0){
              $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
            }
          }
        }, function(){
          if(boxComment[0]){
            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
          }
        });

        $scope.$on('notification', function(e, data) {
          if (data.type === 'COMMENT') {
            var c = {
              id: data.message.id,
              text: data.message.text,
              createdAt: (new Date()).toISOString(),
              createdBy: data.sourceUser,
              objectRelative: data.publication
            };
            $scope.$apply(function(){
              if(data.message.parentID === 'undefined'){
                if ($scope.comments.length === 4) {
                  $scope.comments.splice($scope.comments.length - 1, 1);
                }
                $scope.comments.unshift(c);
              }else{
                angular.forEach($scope.comments, function(item){
                  if(item.id === data.message.parentID){
                    if(!item.commentChild){
                      item.commentChild = [];
                    }
                    item.commentChild.push(c);
                  }
                });
              }
            });
          }
        });
      }else{
        if(boxComment[0]){
          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
        }
      }
      
      var boxReminder = $scope.role.template.data.filter(function(d){ return d.columnType === 'REMINDER'; });
      if ($scope.info.features.reminders && $scope.role.showReminder && !$scope.showAll) {
        CompanyTaskService.query({companyId: $stateParams.companyId, status: 'INCOMPLETE', limit: 4}).$promise.then(function(resp){
          $scope.latestTasks = resp;
          if(!boxReminder[0]){
            if($scope.latestTasks.length > 0){
              $scope.role.template.data.push({
                isChart: false,
                centralInformation: false,
                columnType: 'REMINDER',
                isFullBox: false,
                chartData: {
                  gsX: 0,
                  gsY: yMax+heigthMax,
                  gsWidth: 4,
                  gsHeigth: 4,
                }
              });
              setTimeout(function(){
                var grid = jQuery('.grid-stack').data('gridstack');
                grid.addWidget(jQuery('.grid-stack-item:last-child'), 0, yMax+heigthMax, 4, 4, true);
              }, 1000);
            }
          }else{
            if($scope.latestTasks.length === 0){
              $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
            }
          }
        }, function(){
          if(boxReminder[0]){
            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
          }
        });
      }else{
        if(boxReminder[0]){
          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
        }
      }

      $scope.checkColors = function(xAxesDisplay){
        if($scope.role.template && $scope.role.template.id){
          angular.forEach($scope.role.template.data, function(v, k){
            if(v.isChart && v.chartData){
              if(v.chartData.type === 'line-bar'){
                $scope.role.template.data[k].options = {
                  legend: { 
                    display: true , 
                    position: 'bottom'
                  },
                  scales: {
                    xAxes: [{
                      ticks: {
                        display: true
                      }
                    }],
                    yAxes: []
                  }
                };
                if(xAxesDisplay <= 483){
                  $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                }else{
                  if(xAxesDisplay < 999){
                    if(xAxesDisplay > 807){
                      if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
                        if(k === 0){
                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                        }else{
                          if($scope.role.template.id === '6'){
                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                          }else{
                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                          }
                        }
                      }else{
                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                      }
                    }else{
                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                    }
                  }else{
                    if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                    }
                  }
                }
              }else{
                $scope.role.template.data[k].options = { 
                  legend: { 
                    display: true, 
                    position: 'bottom'
                  }
                };
                if(v.chartData.type === 'bar' || v.chartData.type === 'line'){
                  $scope.role.template.data[k].options = { 
                    legend: { 
                      display: true, 
                      position: 'bottom'
                    },
                    scales: {
                      xAxes: [{
                        ticks: {
                          display: true
                        }
                      }]
                    } 
                  };
                  if(xAxesDisplay <= 483){
                    $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                  }else{
                    if(xAxesDisplay < 999){
                      if(xAxesDisplay > 807){
                        if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
                          if(k === 0){
                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                          }else{
                            if($scope.role.template.id === '6'){
                              $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                            }else{
                              $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                            }
                          }
                        }else{
                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                        }
                      }else{
                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                      }
                    }else{
                      if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                      }
                    }
                  }
                }
              }
              if(v.chartData.type !== 'doughnut' && v.chartData.type !== 'pie'){
                $scope.role.template.data[k].datasetOverride = [];
                angular.forEach(v.chartData.colors, function(value, key){
                  if(v.chartData.type === 'line-bar'){
                    $scope.role.template.data[k].datasetOverride.push({
                      yAxisID: 'y-axis-'+(key+1),
                      borderWidth: key === 0 ? 2 : 1,
                      backgroundColor: key === 0 ? 'transparent' : value,
                      pointBackgroundColor: key === 0 ? 'transparent' : value,
                      borderColor: value,
                      pointBorderColor: value,
                      type: key === 0 ? 'line' : 'bar'
                    });
                    $scope.role.template.data[k].options.scales.yAxes.push({
                      id: 'y-axis-'+(key+1),
                      display: true,
                      position: key === 0 ? 'left' : 'right'
                    });
                  }else{
                    $scope.role.template.data[k].datasetOverride.push({
                      borderWidth: v.chartData.type === 'line' ? 2 : 1,
                      backgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
                      pointBackgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
                      borderColor: value,
                      pointBorderColor: value
                    });
                  }
                });
              }
            }
          });
        }
      };

      var widthWindow = angular.element($window).width();
      $scope.checkColors(widthWindow);
      angular.element($window).on('resize', function () {
        widthWindow = angular.element($window).width();
        $scope.$apply(function(){
          $scope.checkColors(widthWindow);
        });
      });
    }
    
    if($scope.role && $scope.role.template !== null) {
      $scope.userLinks = angular.isDefined($scope.userInfo.features.userLinks) ? $scope.userInfo.features.userLinks : [];
    }
  }

  if(window.localStorage && window.localStorage.needToFetchDashboard === 'true') {
    if(stateSnapshot.previous.state.name === 'root.company.publications-list'){
      window.localStorage.needToFetchDashboard = false;
      $state.go(stateSnapshot.previous.state.name, stateSnapshot.previous.params, {reload: true});
    }else{
      if($state.current.name === 'root.company.publications-list'){
        window.localStorage.needToFetchDashboard = false;
        $state.reload();
      }
    }
  }


  if($stateParams.q !== ''){
     $window.scrollTo(0,0);
  }

  $scope.removeTag = function (tag) {
    $scope.activeTags.splice($scope.activeTags.indexOf(tag), 1);
    var tagQuery = null;
    if ($scope.activeTags.length > 0) {
      tagQuery = $scope.activeTags.join(',');
    }
    $state.go($state.current.name, {tags: tagQuery});
  };

  $scope.removeCategoryFilter = function() {
    $state.go($state.current.name, {categoryId: null});
  };

  $scope.removeTypeFilter = function() {
    $state.go($state.current.name, {type: null});
  };

  $scope.removeGroupFilter = function() {
    $state.go($state.current.name, {groupId: null});
  };

  $scope.removePriorityFilter = function() {
    $state.go($state.current.name, {priorityId: null});
  };

  $scope.removeDateFilter = function(t) {
    if (t === 'from') {
      $state.go($state.current.name, {from: null});
    }
    if (t === 'to') {
      $state.go($state.current.name, {to: null});
    }
  };

  $scope.page = $stateParams.page|0;
  $scope.companyId = $stateParams.companyId;

  $scope.getHiddenGroupName = function (publicationGroups) {
    for (var length = publicationGroups.length, i = 0; i < length; i++) {
      for (var groupLength = $scope.groups.length, j = 0; j < groupLength; j++) {
        if ($scope.groups[j].id === publicationGroups[i]) {
          return $scope.groups[j].name;
        }
      }
    }

    return '';
  };

  $scope.uploadFile = function(publication, $files) {
    if (publication.type === 'NOTE') {
      growl.addErrorMessage(translations['publication.file-upload-impossible']);
      return false;
    }
    if (publication.uploadLock) {
      growl.addErrorMessage(translations['publication.file-upload-locked']);
      return false;
    }
    else {
      $scope.uploadFilesForPublication($files, publication.id);
    }
  };

  $scope.checkUploadLock = function(publication) {
    if (publication.type === 'NOTE') {
      return 'upload--forbidden';
    }
    else if (publication.uploadLock) {
      return 'upload--locked';
    }
    else {
      return 'upload--possible';
    }
  };


  // Paging for categories
  $scope.pageCat = parseInt($stateParams.pageCat, 10) || 1;
  if ($scope.categories.length === 21) {
    $scope.moreCat = true;
  }
}

CompanyPublicationsListCtrl.resolve = {
  publications: ['$stateParams', 'CompanyPublicationService', function ($stateParams, CompanyPublicationService) {
    var companyId = $stateParams.companyId,
      filter = {};

    filter.companyId = companyId;

    if ($stateParams.type !== '') {
      filter.type = $stateParams.type;
    }

    if ($stateParams.q !== '') {
      filter.q     = $stateParams.q;
      filter.qType = $stateParams.qType || 'GENERAL';
      if (filter.qType === 'REFERENCE' || filter.qType === 'KEYPASS') {
        if (filter.qType === 'REFERENCE') {
          filter.reference = filter.q;
        } else if (filter.qType === 'KEYPASS') {
          filter.keypass = filter.q;
          filter.type = 'KEYPASS';
        }
        filter.q = '';
        filter.qType = '';
      }
    }

    if ($stateParams.categoryId !== '') {
      filter.categoryId = $stateParams.categoryId;
    }

    if ($stateParams.priorityId !== '') {
      filter.priorityId = $stateParams.priorityId;
    }

    if ($stateParams.tags !== '') {
      if (Array.isArray($stateParams.tags)) {
        filter.tags = $stateParams.tags.join(',');
      } else {
        filter.tags = $stateParams.tags;
      }
    }

    if ($stateParams.groupId !== '') {
      filter.groupId = $stateParams.groupId;
    }

    if ($stateParams.year && $stateParams.year !== '') {
      filter.year = $stateParams.year;
    }

    if ($stateParams.month && $stateParams.month !== '') {
      filter.month = $stateParams.month;
    }

    if ($stateParams.from) {
      filter.from = $stateParams.from;
    }

    if ($stateParams.to) {
      filter.to = $stateParams.to;
    }

    filter.orderby = 'updated';
    if ($stateParams.orderby) {
      filter.orderby = $stateParams.orderby;
    }
    if ($stateParams.asc) {
      filter.asc = $stateParams.asc;
    }
    if ($stateParams.qTypeObject && $stateParams.qTypeObject === 'ARCHIVED') {
      filter.archived = true;
    }
    // Fetch 21 for pagination, but the offset should be using 20
    filter.limit = 61;
    filter.offset = ($stateParams.page|0) * 60;

    return CompanyPublicationService.query(filter).$promise;
  }],
  currentCategory: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
    if ($stateParams.categoryId) {
      return CompanyCategoryService.get({
        companyId: $stateParams.companyId,
        categoryId: $stateParams.categoryId
      }).$promise;
    }
  }],
  translations: ['$translate', function ($translate) {
    return $translate([
      'list',
      'all-cards',
      'publication.file-upload-locked',
      'publication.file-upload-impossible'
    ]);
  }]
};
module.exports = CompanyPublicationsListCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationsListCtrl', [
    '$scope',
    '$stateParams',
    'stateSnapshot',
    '$state',
    '$modal',
    '$timeout',
    '$controller',
    'publications',
    'categories',
    'currentCategory',
    'priorities',
    'userInformation',
    'translations',
    'CompanyGroupService',
    'CompanyMessageService',
    'CompanyCommentsService',
    'CompanyPublicationService',
    'growl',
    'reloadUserRoleDashboard',
    'CompanyTaskService', 
    'CompanyUserService',
    '$window',
    CompanyPublicationsListCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationsListCtrl.js
// module id = 385
// module chunks = 0